var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fixed right-0 inset-y-0 w-full max-w-sm bg-white z-80" },
    [
      _c("div", { staticClass: "flex flex-col h-full" }, [
        _c("div", { staticClass: "px-6 py-5 lg:py-6 border-b bg-white" }, [
          _c("div", { staticClass: "grid grid-cols-6" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-span-4 col-start-2 lg:col-start-1 lg:col-span-5 text-md lg:text-lg flex justify-center lg:justify-start items-center space-x-3",
              },
              [
                _c(
                  "div",
                  { staticClass: "h-5 w-5 block" },
                  [_c("IconFavourites")],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "leading-none" }, [
                  _vm._v("Favourites (" + _vm._s(_vm.items.length) + ")"),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-span-1 justify-end flex items-center" },
              [
                _c(
                  "button",
                  {
                    staticClass: "link",
                    on: {
                      click: function ($event) {
                        return _vm.$store.commit("closeSiteFavourites")
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "w-5 h-5" }, [_c("IconCross")], 1),
                    _vm._v(" "),
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v("Close favourites list"),
                    ]),
                  ]
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "h-full overflow-y-auto scrolling-touch" },
          [
            _vm._l(_vm.items, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "px-6 pt-6 pb-4 flex flex-col items-between",
                  class: `text-${item.textColour.value || item.textColour}`,
                  style: { backgroundColor: item.hex },
                },
                [
                  _c(
                    "div",
                    { staticClass: "mb-24" },
                    [
                      _c("div", { staticClass: "font-bold text-md mb-2" }, [
                        _vm._v(_vm._s(item.title)),
                      ]),
                      _vm._v(" "),
                      _vm.testPotProductId && _vm.getTestPot(item)
                        ? _c(
                            "ProductColourTestPot",
                            {
                              attrs: {
                                link: "",
                                "test-pot": _vm.getTestPot(item),
                                source: "favourites_list",
                                "paint-colour": item.hex || "",
                                "colour-title": item.title || "",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(item.title) +
                                  " Test Pot - $" +
                                  _vm._s(_vm.getTestPot(item).salePrice)
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "link underline text-left",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.removeFavourite(item)
                        },
                      },
                    },
                    [_vm._v("\n          Remove\n        ")]
                  ),
                ]
              )
            }),
            _vm._v(" "),
            _vm.items.length == 0
              ? _c(
                  "div",
                  {
                    staticClass: "p-6 text-center",
                    attrs: { "data-testid": "empty-favourites-message" },
                  },
                  [
                    _vm._v(
                      "\n        You haven't added any colours to your favourites. Visit the\n        "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "link underline",
                        attrs: { href: "/colours" },
                      },
                      [_vm._v("colours")]
                    ),
                    _vm._v(
                      " page to start\n        adding your favourite colours.\n      "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.items.length
              ? _c(
                  "div",
                  { staticClass: "p-6 bg-white text-center lg:text-left" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn-soft",
                        on: {
                          click: function ($event) {
                            _vm.isSendFormOpen = true
                          },
                        },
                      },
                      [_vm._v("\n          Email me my favourites\n        ")]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _c(
            "Modal",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isSendFormOpen,
                  expression: "isSendFormOpen",
                },
              ],
              on: {
                close: function ($event) {
                  _vm.isSendFormOpen = false
                },
              },
            },
            [
              _c("SiteFavouritesEmailForm", {
                attrs: { favourites: _vm.items },
                on: {
                  close: function ($event) {
                    return _vm.handleEmailFormSubmit()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }